<div class="w-full  animate-fade-in pb-8 relative">
    <!-- Header Shared Component -->
    <app-section-header [title]="'Perfil de Negocio'" [description]="'Organización | Editar'"
        icon="mdi:office-building-outline" [showBack]="false">
    </app-section-header>

    <div [formGroup]="form" class="grid grid-cols-1 lg:grid-cols-12 gap-3.5">

        <!-- Left: Editable Profile -->
        <div class="lg:col-span-7 space-y-3.5 animate-fade-in-up" style="animation-delay: 0.1s">

            <!-- Contact Section -->
            <div class="compact-section space-y-4 shadow-lg shadow-black/[0.01]">
                <h2
                    class="flex items-center gap-2 text-[10px] md:text-xs font-black uppercase tracking-tight text-foreground/75">
                    <span class="w-5 h-5 rounded-md bg-primary/10 flex items-center justify-center text-primary">
                        <iconify-icon icon="mdi:account-edit-outline" width="12"></iconify-icon>
                    </span>
                    Identidad & Contacto
                </h2>

                <!-- Business Logo Section -->
                <div class="relative group mb-6">
                    <div *ngIf="logoPreview() || currentBusiness()?.invoiceLogoUrl || currentBusiness()?.logoUrl"
                        class="p-4 bg-foreground/[0.01] border border-foreground/[0.03] rounded-2xl flex items-center gap-4 transition-all hover:border-primary/20">
                        <div
                            class="w-20 h-20 rounded-xl bg-white shadow-sm border border-foreground/5 flex items-center justify-center overflow-hidden p-2 shrink-0">
                            <img [src]="logoPreview() || getLogoUrl(currentBusiness()?.invoiceLogoUrl! || currentBusiness()?.logoUrl!)"
                                class="w-full h-full object-contain" />
                        </div>
                        <div class="flex-grow min-w-0">
                            <div class="flex items-center gap-1.5 mb-1.5">
                                <span
                                    class="px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-600 text-[8px] font-black uppercase">Activo</span>
                                <iconify-icon [icon]="logoPreview() ? 'mdi:sync' : 'mdi:check-decagram'"
                                    [class]="logoPreview() ? 'text-primary animate-spin-slow' : 'text-emerald-500'"
                                    width="12"></iconify-icon>
                            </div>
                            <h4 class="text-[10px] font-bold text-slate-800 dark:text-white/90 uppercase truncate">{{
                                logoPreview() ?
                                'Nueva Imagen' : 'Logo del Negocio' }}</h4>
                            <p class="text-[8px] text-foreground/45 uppercase tracking-widest font-bold mb-2">Identidad
                                Visual de la Marca</p>
                            <div class="flex gap-2">
                                <button type="button" (click)="logoInput.click()"
                                    class="h-7 px-4 bg-primary text-white text-[8px] font-black uppercase rounded hover:bg-primary/90 transition-all flex items-center gap-1.5 shadow-sm shadow-primary/20">
                                    Cambiar Logo
                                </button>
                                <button *ngIf="logoPreview()" type="button" (click)="clearLogoSelection()"
                                    class="h-7 w-7 flex items-center justify-center bg-red-500/10 text-red-500 rounded-lg hover:bg-red-500/20 transition-all">
                                    <iconify-icon icon="mdi:close" width="14"></iconify-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Empty Logo State -->
                    <div *ngIf="!logoPreview() && !currentBusiness()?.invoiceLogoUrl && !currentBusiness()?.logoUrl"
                        (click)="logoInput.click()"
                        class="p-6 border-2 border-dashed border-foreground/10 rounded-2xl flex flex-col items-center justify-center gap-3 cursor-pointer hover:border-primary/30 hover:bg-primary/5 transition-all group/empty">
                        <iconify-icon icon="mdi:image-plus-outline" width="24"
                            class="text-foreground/20 group-hover/empty:text-primary/40"></iconify-icon>
                        <span class="text-[9px] font-black uppercase tracking-widest text-foreground/75">Cargar Logo del
                            Negocio</span>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-3.5">
                    <app-input label="Nombre Comercial / Marca" formControlName="commercialName" icon="mdi:tag-outline"
                        placeholder="Ej: DentalHealth Premium" size="sm"></app-input>

                    <app-input label="Dirección Matriz" formControlName="address" icon="mdi:map-marker-outline"
                        placeholder="Calle Ejemplo N12 y Av. Central" size="sm"></app-input>

                    <app-input label="Dirección del Establecimiento" formControlName="establishmentAddress"
                        icon="mdi:map-marker-radius-outline"
                        placeholder="Dirección específica que aparecerá en sus facturas" size="sm"></app-input>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                        <app-input label="Teléfono Público" formControlName="phone" icon="mdi:phone-outline"
                            placeholder="0999999999" size="sm"></app-input>
                        <app-input label="Email de contacto" formControlName="email" icon="mdi:email-outline"
                            placeholder="contacto@clinca.com" size="sm"></app-input>
                    </div>
                </div>
            </div>




        </div>

        <!-- Right: System Information (Locked) -->
        <div class="lg:col-span-5 space-y-3.5 animate-fade-in-up" style="animation-delay: 0.2s">

            <div class="compact-section-locked">
                <div class="flex items-center gap-2.5 mb-3.5">
                    <div
                        class="w-7 h-7 rounded-full bg-foreground/5 flex items-center justify-center text-foreground/75">
                        <iconify-icon icon="mdi:lock-outline" width="14"></iconify-icon>
                    </div>
                    <div>
                        <h2
                            class="section-title leading-tight text-[10px] md:text-xs font-black uppercase tracking-tight">
                            Estructura & Control</h2>
                        <p class="text-[8px] text-foreground/75 italic uppercase tracking-widest font-bold">Resguardado
                            por Seguridad Core</p>
                    </div>
                </div>

                <div class="space-y-3.5">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                        <div class="input-locked"><app-input label="RUC / ID Fiscal" formControlName="taxId"
                                icon="mdi:card-text-outline" size="sm"></app-input></div>
                        <div class="input-locked"><app-input label="Razón Social" formControlName="name"
                                icon="mdi:domain" size="sm"></app-input></div>
                    </div>

                    <div class="grid grid-cols-2 gap-3.5">
                        <div class="input-locked"><app-input label="Estab." formControlName="establishmentCode"
                                icon="mdi:store" size="sm" inputClass="font-bold text-center"></app-input></div>
                        <div class="input-locked"><app-input label="Punto Emisión" formControlName="emissionPointCode"
                                icon="mdi:map-marker" size="sm" inputClass="font-bold text-center"></app-input></div>
                    </div>

                    <div class="grid grid-cols-2 gap-3.5">
                        <div class="input-locked"><app-input label="Ambiente SRI" formControlName="environment"
                                icon="mdi:cloud" size="sm"></app-input></div>
                        <div class="input-locked"><app-input label="Regimen" formControlName="regimenType"
                                icon="mdi:gavel" size="sm"></app-input></div>
                    </div>

                    <!-- Locked Status Grid -->
                    <div class="grid grid-cols-3 gap-2 pt-2 border-t border-foreground/[0.03]">
                        <div
                            class="p-2 bg-foreground/[0.03] rounded-xl border border-foreground/[0.02] flex flex-col items-center text-center gap-1">
                            <span class="text-[8px] font-black uppercase text-foreground/45">Contabilidad</span>
                            <iconify-icon
                                [icon]="form.get('obligadoContabilidad')?.value ? 'mdi:check-circle' : 'mdi:close-circle'"
                                [class]="form.get('obligadoContabilidad')?.value ? 'text-primary' : 'text-foreground/10'"
                                width="16"></iconify-icon>
                        </div>
                        <div
                            class="p-2 bg-foreground/[0.03] rounded-xl border border-foreground/[0.02] flex flex-col items-center text-center gap-1">
                            <span class="text-[8px] font-black uppercase text-foreground/45">Contrib. Esp.</span>
                            <iconify-icon
                                [icon]="form.get('isSpecialTaxpayer')?.value ? 'mdi:check-circle' : 'mdi:close-circle'"
                                [class]="form.get('isSpecialTaxpayer')?.value ? 'text-primary' : 'text-foreground/10'"
                                width="16"></iconify-icon>
                        </div>
                        <div
                            class="p-2 bg-primary/5 rounded-xl border border-primary/10 flex flex-col items-center text-center gap-1">
                            <span class="text-[8px] font-black uppercase text-primary">Suscripción</span>
                            <iconify-icon icon="mdi:shield-check" class="text-primary" width="16"></iconify-icon>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Compact Warning -->
            <div class="p-3.5 rounded-2xl bg-amber-500/[0.03] border border-amber-500/10 flex items-start gap-3">
                <iconify-icon icon="mdi:information-outline" class="text-amber-600/70" width="16"></iconify-icon>
                <p class="text-[8px] text-amber-700/60 leading-tight font-bold uppercase tracking-tight">
                    Datos estructurales y fiscales son gestionados exclusivamente por el equipo de soporte técnico.
                </p>
            </div>

            <!-- Invoicing Section -->
            <div class="compact-section space-y-4 shadow-lg shadow-black/[0.01]">
                <h2
                    class="flex items-center gap-2 text-[10px] md:text-xs font-black uppercase tracking-tight text-foreground/75">
                    <span class="w-5 h-5 rounded-md bg-primary/10 flex items-center justify-center text-primary">
                        <iconify-icon icon="mdi:file-certificate-outline" width="12"></iconify-icon>
                    </span>
                    Certificación & Firma
                </h2>

                <div class="grid grid-cols-1 gap-3">
                    <!-- Signature Card -->
                    <div class="p-4 bg-primary/[0.02] border border-primary/5 rounded-2xl space-y-3">
                        <div class="flex items-center justify-between border-b border-primary/5 pb-2">
                            <span class="text-[9px] font-black uppercase tracking-widest text-primary/70">Firma
                                Electrónica (.p12)</span>
                            <iconify-icon *ngIf="currentBusiness()?.signatureLoaded" icon="mdi:shield-check"
                                class="text-emerald-500" width="16"></iconify-icon>
                        </div>

                        <div class="space-y-2">
                            <!-- Loaded State -->
                            <div *ngIf="currentBusiness()?.signatureLoaded && !signatureFileName()"
                                class="flex items-center justify-between p-2 bg-emerald-500/5 rounded-lg border border-emerald-500/10">
                                <div class="flex items-center gap-2 min-w-0">
                                    <div
                                        class="w-6 h-6 rounded bg-emerald-500/10 flex items-center justify-center text-emerald-500 shrink-0">
                                        <iconify-icon icon="mdi:certificate" width="12"></iconify-icon>
                                    </div>
                                    <span
                                        class="text-[8px] font-black uppercase text-emerald-600 truncate">Vigente</span>
                                </div>
                                <button type="button" (click)="signatureInput.click()"
                                    class="text-[7px] font-black uppercase text-emerald-600 hover:underline">Editar</button>
                            </div>

                            <!-- Uploading State -->
                            <div *ngIf="!currentBusiness()?.signatureLoaded || signatureFileName()"
                                class="animate-fade-in space-y-2">
                                <div *ngIf="signatureFileName()"
                                    class="flex items-center justify-between py-1 px-2 bg-primary/5 border border-primary/10 rounded-md">
                                    <span class="text-[7px] font-black uppercase text-primary truncate max-w-[100px]">{{
                                        signatureFileName() }}</span>
                                    <button (click)="clearSignatureSelection()" class="text-red-500"><iconify-icon
                                            icon="mdi:close" width="10"></iconify-icon></button>
                                </div>
                                <div *ngIf="!signatureFileName()" (click)="signatureInput.click()"
                                    class="w-full h-8 border border-dashed border-foreground/10 rounded-lg flex items-center justify-center gap-2 cursor-pointer hover:bg-primary/5">
                                    <iconify-icon icon="mdi:upload" width="12"
                                        class="text-foreground/60"></iconify-icon>
                                    <span class="text-[8px] font-bold uppercase text-foreground/75">Firma .p12</span>
                                </div>
                                <app-input label="Contraseña P12" formControlName="signaturePassword" size="sm"
                                    type="password" icon="mdi:lock-outline"></app-input>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Footer Compacto -->
    <div class="mt-8 pt-6 border-t border-foreground/[0.03]">
        <!-- Error Alert -->
        <div *ngIf="error()"
            class="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-red-500/5 border border-red-500/10 mb-4">
            <iconify-icon icon="mdi:alert-circle" width="14" class="text-red-500"></iconify-icon>
            <p class="text-[9px] font-black uppercase tracking-widest text-red-500">{{ error() }}</p>
            <button (click)="error.set('')" class="ml-auto text-red-500/40 hover:text-red-500">
                <iconify-icon icon="mdi:close" width="14"></iconify-icon>
            </button>
        </div>

        <div class="flex items-center justify-end gap-3">
            <app-button (click)="goBack()" variant="glass" size="xs" iconLeft="mdi:cancel">
                Cancelar
            </app-button>
            <app-button (click)="save()" [disabled]="saving()" size="xs" variant="primary"
                [iconLeft]="saving() ? 'mdi:loading' : 'mdi:content-save-check-outline'" [loading]="saving()"
                class="min-w-[170px] shadow-lg shadow-primary/20">
                Actualizar Perfil
            </app-button>
        </div>
    </div>



    <!-- Hidden Inputs -->
    <input #logoInput type="file" (change)="onFileSelected($event, 'logo')" accept="image/*" class="hidden" />
    <input #signatureInput type="file" (change)="onFileSelected($event, 'signature')" accept=".p12,.pfx"
        class="hidden" />
</div>